import React, { useState } from 'react';
import {
    UtensilsCrossed,
    Calendar,
    Wheat,
    Leaf,
    Drumstick,
    ChevronDown,
    Flame,
    AlertCircle
} from 'lucide-react';

import { FileImage } from 'lucide-react';

const Menu = () => {
    const [activeCategory, setActiveCategory] = useState('special');
    const [activeSection, setActiveSection] = useState('categories');

    const sections = [
        { id: 'categories', name: 'Menu Categories', shortName: 'Menu', icon: <Wheat size={18} /> },
        // { id: 'lunch-combos', name: 'Lunch Combinations', shortName: 'Lunch', icon: <UtensilsCrossed size={18} /> },
        // { id: 'daily-menu', name: 'Daily Specials', shortName: 'Daily', icon: <Calendar size={18} /> },
        // { id: 'menu-photo', name: 'Full Menu Photo', shortName: 'Photo', icon: <FileImage size={18} /> }
    ];

    const categories = [
        { id: 'special', name: 'Special Menu', shortName: 'Special', icon: <Drumstick size={18} /> },
        { id: 'daily', name: 'Daily Menu', shortName: 'Daily', icon: <Leaf size={18} /> }
    ];

    const menuItems = {
        'special': [
            {
                id: 'chilli-chicken',
                name: 'Chilli Chicken / Chili-Hähnchen',
                description: 'Spicy chicken stir-fry with bell peppers and onions / Scharfes Hähnchen-Pfannengericht mit Paprika und Zwiebeln',
                longDescription: 'Tender chicken pieces wok-tossed with bell peppers, onions, and a spicy chilli sauce for a perfect Indo-Chinese fusion dish. / Zartes Hähnchenfleisch im Wok mit Paprika, Zwiebeln und scharfer Chili-Sauce für ein perfektes indo-chinesisches Fusionsgericht.',
                price: 10.95,
                isVeg: false,
                isSpicy: true,
                allergens: 'May contain gluten, soy / Kann Gluten, Soja enthalten'
            },
            {
                id: 'fried-rice',
                name: 'Fried Rice / Gebratener Reis',
                description: 'Indo-Chinese style fried rice with vegetables / Indo-chinesischer gebratener Reis mit Gemüse',
                longDescription: 'Fragrant basmati rice stir-fried with mixed vegetables, eggs, and aromatic spices in Indo-Chinese style. / Duftender Basmati-Reis mit gemischtem Gemüse, Eiern und aromatischen Gewürzen im indo-chinesischen Stil gebraten.',
                price: 6.95,
                isVeg: true,
                isSpicy: false,
                allergens: 'May contain gluten, eggs / Kann Gluten, Eier enthalten'
            },
            {
                id: 'chicken-chowmein',
                name: 'Chicken Chowmein / Hähnchen-Nudeln',
                description: 'Stir-fried noodles with chicken and vegetables / Gebratene Nudeln mit Hähnchen und Gemüse',
                longDescription: 'Hakka-style noodles stir-fried with chicken, vegetables, and savory sauces for a delicious Indo-Chinese favorite. / Nudeln im Hakka-Stil mit Hähnchen, Gemüse und herzhaften Saucen gebraten – ein köstlicher indo-chinesischer Favorit.',
                price: 9.95,
                isVeg: false,
                isSpicy: false,
                allergens: 'Gluten, wheat, may contain soy, eggs / Gluten, Weizen, kann Soja, Eier enthalten'
            },
            {
                id: 'momo',
                name: 'Momo / Momos (Dumplings)',
                description: 'Steamed Nepali dumplings filled with spiced meat or vegetables / Gedämpfte nepalesische Teigtaschen gefüllt mit gewürztem Fleisch oder Gemüse',
                longDescription: 'Traditional Nepali steamed dumplings served with a spicy tomato-sesame chutney. / Traditionelle nepalesische gedämpfte Teigtaschen serviert mit würzigem Tomaten-Sesam-Chutney.',
                price: 8.95,
                isVeg: false,
                isSpicy: true,
                allergens: 'Gluten, wheat / Gluten, Weizen'
            },
            {
                id: 'chicken-curry',
                name: 'Chicken Curry / Hähnchen-Curry',
                description: 'Tender chicken pieces in an aromatic curry sauce / Zartes Hähnchenfleisch in aromatischer Curry-Sauce',
                longDescription: 'Classic chicken curry with succulent pieces simmered in a rich gravy made with onions, tomatoes, and traditional Indian spices. / Klassisches Hähnchen-Curry mit saftigen Stücken, geschmort in einer reichhaltigen Soße aus Zwiebeln, Tomaten und traditionellen indischen Gewürzen.',
                price: 9.95,
                isVeg: false,
                isSpicy: true,
                allergens: 'None / Keine'
            },
            {
                id: 'chilli-paneer',
                name: 'Chilli Paneer / Chili-Paneer',
                description: 'Spicy cottage cheese stir-fry with bell peppers / Scharfes Paneer-Pfannengericht mit Paprika',
                longDescription: 'Cottage cheese cubes wok-tossed with bell peppers, onions, and spicy chilli sauce in Indo-Chinese style. / Paneer-Würfel im Wok mit Paprika, Zwiebeln und scharfer Chili-Sauce im indo-chinesischen Stil.',
                price: 9.95,
                isVeg: true,
                isSpicy: true,
                allergens: 'Dairy, may contain gluten, soy / Milchprodukte, kann Gluten, Soja enthalten'
            }
        ],
        'daily': [
            {
                id: 'aloo-matar',
                name: 'Aloo Matar / Kartoffeln mit Erbsen',
                description: 'Potatoes and green peas in a spiced tomato gravy / Kartoffeln und grüne Erbsen in würziger Tomatensoße',
                longDescription: 'A comforting curry featuring tender potatoes and green peas cooked in a flavorful tomato-based sauce with aromatic spices. / Ein wohltuendes Curry mit zarten Kartoffeln und grünen Erbsen in einer würzigen Tomatensoße mit aromatischen Gewürzen.',
                price: 7.95,
                isVeg: true,
                isSpicy: false,
                allergens: 'None / Keine'
            },
            {
                id: 'zeera-rice',
                name: 'Zeera Rice / Kreuzkümmel-Reis',
                description: 'Basmati rice tempered with cumin seeds / Basmati-Reis mit Kreuzkümmel',
                longDescription: 'Fragrant basmati rice cooked with aromatic cumin seeds that add a warm, earthy flavor. / Duftender Basmati-Reis gekocht mit aromatischen Kreuzkümmelsamen, die einen warmen, erdigen Geschmack verleihen.',
                price: 3.95,
                isVeg: true,
                isSpicy: false,
                allergens: 'None / Keine'
            },
            {
                id: 'yellow-daal',
                name: 'Yellow Daal / Gelbes Linsen-Dal',
                description: 'Yellow lentils tempered with cumin and garlic / Gelbe Linsen mit Kreuzkümmel und Knoblauch',
                longDescription: 'Comfort food staple featuring yellow lentils slow-cooked and finished with a tadka of cumin seeds, garlic, and spices. / Hausmannskost-Klassiker mit langsam gekochten gelben Linsen, verfeinert mit Tadka aus Kreuzkümmel, Knoblauch und Gewürzen.',
                price: 6.95,
                isVeg: true,
                isSpicy: false,
                allergens: 'May contain dairy / Kann Milchprodukte enthalten'
            },
            {
                id: 'mixed-veg',
                name: 'Mixed Veg / Gemischtes Gemüse',
                description: 'Assorted vegetables in a mildly spiced curry / Verschiedene Gemüsesorten in mild gewürztem Curry',
                longDescription: 'A healthy medley of seasonal vegetables cooked in a lightly spiced gravy. / Eine gesunde Mischung aus saisonalem Gemüse, gekocht in einer leicht gewürzten Soße.',
                price: 7.95,
                isVeg: true,
                isSpicy: false,
                allergens: 'None / Keine'
            },
            {
                id: 'matar-paneer',
                name: 'Matar Paneer / Erbsen mit Paneer',
                description: 'Cottage cheese and green peas in a creamy tomato sauce / Paneer und grüne Erbsen in cremiger Tomatensoße',
                longDescription: 'Handmade cottage cheese cubes and tender green peas simmered in a rich, aromatic tomato gravy. / Hausgemachte Paneer-Würfel und zarte grüne Erbsen geschmort in einer reichhaltigen, aromatischen Tomatensoße.',
                price: 8.95,
                isVeg: true,
                isSpicy: false,
                allergens: 'Dairy, may contain traces of nuts / Milchprodukte, kann Spuren von Nüssen enthalten'
            },
            {
                id: 'puri',
                name: 'Puri / Puri (Frittiertes Brot)',
                description: 'Deep-fried, puffed Indian bread / Frittiertes, aufgeblähtes indisches Brot',
                longDescription: 'Light and fluffy whole wheat bread deep-fried until golden and puffed. / Leichtes und fluffiges Vollkornbrot, frittiert bis es goldbraun und aufgebläht ist.',
                price: 2.50,
                isVeg: true,
                isSpicy: false,
                allergens: 'Gluten, wheat / Gluten, Weizen'
            },
            {
                id: 'papad',
                name: 'Extra Papad / Papadam',
                description: 'Crispy lentil wafer / Knuspriger Linsen-Fladen',
                longDescription: 'Thin, crispy lentil crackers roasted or fried to perfection. / Dünne, knusprige Linsen-Cracker, perfekt geröstet oder frittiert.',
                price: 1.50,
                isVeg: true,
                isSpicy: false,
                allergens: 'May contain lentils / Kann Linsen enthalten'
            },
            {
                id: 'salad',
                name: 'Extra Salad / Salat',
                description: 'Fresh mixed salad with Indian dressing / Frischer gemischter Salat mit indischem Dressing',
                longDescription: 'Fresh vegetables with cucumber, tomatoes, onions, and lemon dressing. / Frisches Gemüse mit Gurken, Tomaten, Zwiebeln und Zitronen-Dressing.',
                price: 3.95,
                isVeg: true,
                isSpicy: false,
                allergens: 'None / Keine'
            }
        ]
    };

    const lunchCombos = [
        {
            id: 'combo-1',
            name: 'Rice + Dal Tadka + Aloo Matar',
            description: 'Steamed rice served with yellow lentils and potato-pea curry / Gedämpfter Reis serviert mit gelben Linsen und Kartoffel-Erbsen-Curry',
            price: 9.95,
            isVeg: true
        },
        {
            id: 'combo-2',
            name: 'Rice + Dal Tadka + Mutter Paneer',
            description: 'Steamed rice served with yellow lentils and cottage cheese-pea curry / Gedämpfter Reis serviert mit gelben Linsen und Paneer-Erbsen-Curry',
            price: 10.95,
            isVeg: true
        },
        // {
        //     id: 'combo-3',
        //     name: 'Rice + Dal Tadka + Chicken Curry',
        //     description: 'Steamed rice served with yellow lentils and our signature chicken curry',
        //     price: 11.95,
        //     isVeg: false
        // },
        {
            id: 'combo-4',
            name: 'Rice + Dal Tadka + Palak Paneer',
            description: 'Steamed rice served with yellow lentils and spinach cottage cheese curry / Gedämpfter Reis serviert mit gelben Linsen und Spinat-Paneer-Curry',
            price: 10.95,
            isVeg: true
        },
        // {
        //     id: 'combo-5',
        //     name: 'Rice + Dal Tadka + Butter Chicken',
        //     description: 'Steamed rice served with yellow lentils and creamy tomato chicken curry',
        //     price: 12.95,
        //     isVeg: false
        // },
        {
            id: 'combo-6',
            name: 'Rice + Chana Masala + Bhindi Fry',
            description: 'Steamed rice served with chickpea curry and okra stir-fry / Gedämpfter Reis serviert mit Kichererbsen-Curry und gebratenem Okra',
            price: 10.95,
            isVeg: true
        }
    ];

    const dailyMenu = [
        {
            day: 'Monday',
            items: [
                {
                    id: 'monday-veg',
                    name: 'Veg Special: Rice + Dal Tadka + Mutter Paneer',
                    price: 12.95,
                    isVeg: true,
                    isSpicy: false,
                    description: 'A vegetarian delight with rice, dal, and creamy peas and paneer curry. / Ein vegetarischer Genuss mit Reis, Dal und cremigem Erbsen-Paneer-Curry.'
                },
                // {
                //     id: 'monday-nonveg',
                //     name: 'Non-Veg Special: Rice + Dal Tadka + Butter Chicken',
                //     price: 14.95,
                //     isVeg: false,
                //     isSpicy: false,
                //     description: 'A perfect combination of fluffy rice, creamy dal, and our signature butter chicken.'
                // }
            ]
        },
        {
            day: 'Tuesday',
            items: [
                {
                    id: 'tuesday-veg',
                    name: 'Veg Special: Rice + Chana Masala + Aloo Dum',
                    price: 11.95,
                    isVeg: true,
                    isSpicy: true,
                    description: 'A vegetarian feast with rice, chickpeas, and spiced potatoes. / Ein vegetarisches Festmahl mit Reis, Kichererbsen und gewürzten Kartoffeln.'
                },
                // {
                //     id: 'tuesday-nonveg',
                //     name: 'Non-Veg Special: Rice + Chana Masala + Chicken Curry',
                //     price: 13.95,
                //     isVeg: false,
                //     isSpicy: true,
                //     description: 'A flavorful combination of rice, tangy chickpeas, and spicy chicken curry.'
                // }
            ]
        },
        {
            day: 'Wednesday',
            items: [
                {
                    id: 'wednesday-veg',
                    name: 'Veg Special: Rice + Dal Tadka + Palak Paneer',
                    price: 12.95,
                    isVeg: true,
                    isSpicy: false,
                    description: 'A healthy combination of rice, dal, and spinach paneer curry. / Eine gesunde Kombination aus Reis, Dal und Spinat-Paneer-Curry.'
                },
                // {
                //     id: 'wednesday-nonveg',
                //     name: 'Non-Veg Special: Rice + Dal Tadka + Mutton Kotha',
                //     price: 15.95,
                //     isVeg: false,
                //     isSpicy: true,
                //     description: 'A hearty meal of rice, dal, and slow-cooked mutton in rich gravy.'
                // }
            ]
        },
        {
            day: 'Thursday',
            items: [
                {
                    id: 'thursday-veg',
                    name: 'Veg Special: Rice + Chana Masala + Bhindi Fry',
                    price: 11.95,
                    isVeg: true,
                    isSpicy: true,
                    description: 'A flavorful vegetarian combo with rice, chickpeas, and crispy spiced okra. / Eine würzige vegetarische Kombination mit Reis, Kichererbsen und knusprigem gewürztem Okra.'
                },
                // {
                //     id: 'thursday-nonveg',
                //     name: 'Non-Veg Special: Rice + Chana Masala + Fish Curry',
                //     price: 14.50,
                //     isVeg: false,
                //     isSpicy: true,
                //     description: 'A seafood special with aromatic rice, chickpeas, and coastal-style fish curry.'
                // }
            ]
        },
        {
            day: 'Friday',
            items: [
                {
                    id: 'friday-veg',
                    name: 'Veg Special: Rice + Dal Tadka + Aloo Dum',
                    price: 11.95,
                    isVeg: true,
                    isSpicy: false,
                    description: 'A satisfying vegetarian meal with rice, dal, and slow-cooked potatoes. / Eine sättigende vegetarische Mahlzeit mit Reis, Dal und langsam gekochten Kartoffeln.'
                },
                // {
                //     id: 'friday-nonveg',
                //     name: 'Non-Veg Special: Rice + Dal Tadka + Chicken Vindaloo',
                //     price: 13.95,
                //     isVeg: false,
                //     isSpicy: true,
                //     description: 'End your week with this spicy combination of rice, dal, and tangy chicken vindaloo.'
                // }
            ]
        }
    ];

    // Indicator component for vegetarian/spicy
    const FoodIndicator = ({ isVeg, isSpicy }) => (
        <div className="flex flex-wrap gap-2">
            {isVeg ? (
                <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded flex items-center">
                    <Leaf size={12} className="mr-1" /> Veg
                </span>
            ) : (
                <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded flex items-center">
                    <Drumstick size={12} className="mr-1" /> Non-Veg
                </span>
            )}

            {isSpicy && (
                <span className="bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded flex items-center">
                    <Flame size={12} className="mr-1" /> Spicy
                </span>
            )}
        </div>
    );

    // Menu item card
    const MenuItem = ({ item }) => (
        <div className="p-4 border-b border-gray-200 transition-colors" style={{ '&:hover': { backgroundColor: '#f5f7f0' } }}>
            <div className="flex justify-between items-start">
                <div className="flex-1">
                    <h3 className="font-bold text-gray-800">{item.name}</h3>
                    <p className="text-sm text-gray-600 mt-1">{item.description}</p>

                    {item.allergens && (
                        <p className="text-xs text-gray-500 mt-1 flex items-center">
                            <AlertCircle size={12} className="mr-1" />
                            Allergens: {item.allergens}
                        </p>
                    )}

                    <div className="mt-2">
                        <FoodIndicator isVeg={item.isVeg} isSpicy={item.isSpicy} />
                    </div>
                </div>

                <div className="text-right">
                    <span className="font-bold" style={{ color: '#7bae37' }}>€{item.price.toFixed(2)}</span>
                </div>
            </div>
        </div>
    );

    // Lunch combo card
    const ComboItem = ({ combo }) => (
        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-all bg-white">
            <div className="flex justify-between items-start">
                <div className="flex-1">
                    <h3 className="font-bold text-gray-800">{combo.name}</h3>
                    <p className="text-sm text-gray-600 mt-1">{combo.description}</p>

                    <div className="mt-2">
                        {combo.isVeg ? (
                            <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded flex items-center inline-flex">
                                <Leaf size={12} className="mr-1" /> Vegetarian
                            </span>
                        ) : (
                            <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded flex items-center inline-flex">
                                <Drumstick size={12} className="mr-1" /> Non-Vegetarian
                            </span>
                        )}
                    </div>
                </div>

                <div className="text-right">
                    <span className="font-bold" style={{ color: '#7bae37' }}>€{combo.price.toFixed(2)}</span>
                </div>
            </div>
        </div>
    );

    // Daily menu card
    const DailyMenuCard = ({ day, items }) => (
        <div className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-all bg-white">
            <div className="flex justify-between items-start mb-3">
                <h3 className="font-bold text-gray-800">{day}</h3>
            </div>
            <div className="space-y-4">
                {items.map((item) => (
                    <div key={item.id} className="p-3 border border-gray-100 rounded-md">
                        <div className="flex justify-between items-start">
                            <div className="flex-1">
                                <span className="font-medium text-gray-800">{item.name}</span>

                                {item.description && (
                                    <p className="text-sm text-gray-600 mt-1">{item.description}</p>
                                )}

                                <div className="mt-2">
                                    {item.isVeg ? (
                                        <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded flex items-center inline-flex">
                                            <Leaf size={12} className="mr-1" /> Vegetarian
                                        </span>
                                    ) : (
                                        <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded flex items-center inline-flex">
                                            <Drumstick size={12} className="mr-1" /> Non-Vegetarian
                                        </span>
                                    )}

                                    {item.isSpicy && (
                                        <span className="ml-1 mt-1 bg-orange-100 text-orange-800 text-xs px-2 py-1 rounded flex items-center inline-flex">
                                            <Flame size={12} className="mr-1" /> Spicy
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="text-right">
                                <span className="font-bold" style={{ color: '#7bae37' }}>€{item.price.toFixed(2)}</span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );

    return (
        <section id="menu" className="py-16 bg-zinc-50">
            <div className="container mx-auto px-4">
                <div className="text-center mb-10">
                    <h2 className="text-3xl font-bold text-gray-800">Our Menu</h2>
                    <div className="w-24 h-1 mx-auto mt-2" style={{ backgroundColor: '#7bae37' }}></div>
                    <p className="text-gray-600 mt-4">Explore our authentic Indian cuisine</p>
                </div>

                {/* Section Selector - Mobile Responsive */}
                <div className="flex justify-center mb-8 px-2">
                    <div className="w-full max-w-4xl">
                        {/* Mobile: Horizontal scrollable tabs */}
                        {/* <div className="md:hidden">
                            <div className="flex overflow-x-auto gap-2 p-1 bg-white rounded-lg shadow scrollbar-hide">
                                {sections.map((section) => (
                                    <button
                                        key={section.id}
                                        onClick={() => setActiveSection(section.id)}
                                        className={`flex items-center px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap min-w-fit ${activeSection === section.id
                                            ? 'text-white'
                                            : 'text-gray-700 hover:bg-gray-100'
                                            }`}
                                        style={activeSection === section.id ? { backgroundColor: '#7bae37' } : {}}
                                    >
                                        <span className="mr-2">{section.icon}</span>
                                        <span className="hidden xs:inline">{section.shortName}</span>
                                        <span className="xs:hidden">{section.icon}</span>
                                    </button>
                                ))}
                            </div>
                        </div> */}

                        {/* Desktop: Regular layout */}
                        <div className="hidden md:flex justify-center">
                            <div className="inline-flex p-1 bg-white rounded-lg shadow">
                                {sections.map((section) => (
                                    <button
                                        key={section.id}
                                        onClick={() => setActiveSection(section.id)}
                                        className={`flex items-center px-4 py-2 rounded-md text-sm font-medium ${activeSection === section.id
                                            ? 'text-white'
                                            : 'text-gray-700 hover:bg-gray-100'
                                            }`}
                                        style={activeSection === section.id ? { backgroundColor: '#7bae37' } : {}}
                                    >
                                        <span className="mr-2">{section.icon}</span>
                                        {section.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* First Section - Menu Categories */}
                {activeSection === 'categories' && (
                    <div>
                        <div className="flex items-center text-white px-4 py-3 rounded shadow mb-4" style={{ backgroundColor: '#7bae37' }}>
                            <Wheat className="mr-2" size={18} />
                            <h3 className="text-sm font-semibold">Menu Categories</h3>
                            <p className="opacity-90 text-sm ml-auto truncate hidden sm:block">Explore our selection of authentic dishes prepared with fresh ingredients</p>
                        </div>

                        {/* Category Tabs - Mobile Responsive */}
                        <div className="mb-8">
                            {/* Mobile: Horizontal scrollable tabs */}
                            <div className="md:hidden">
                                <div className="flex overflow-x-auto gap-2 bg-white rounded-lg shadow-md border-b border-gray-200 p-2 scrollbar-hide">
                                    {categories.map((category) => (
                                        <button
                                            key={category.id}
                                            onClick={() => setActiveCategory(category.id)}
                                            className={`flex items-center px-3 py-2 rounded-md text-sm font-medium whitespace-nowrap min-w-fit transition-colors ${activeCategory === category.id
                                                ? 'border-2 text-green-600'
                                                : 'text-gray-700 hover:bg-gray-50'
                                                }`}
                                            style={activeCategory === category.id ? { borderColor: '#7bae37', color: '#7bae37' } : {}}
                                        >
                                            <span className="mr-2">{category.icon}</span>
                                            <span className="xs:inline">{category.shortName}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>

                            {/* Desktop: Regular layout */}
                            <div className="hidden md:flex bg-white rounded-lg shadow-md border-b border-gray-200">
                                {categories.map((category) => (
                                    <button
                                        key={category.id}
                                        onClick={() => setActiveCategory(category.id)}
                                        className={`flex-1 py-4 px-4 flex items-center justify-center text-sm font-medium transition-colors ${activeCategory === category.id
                                            ? 'border-b-2 text-green-600'
                                            : 'text-gray-700 hover:bg-gray-50'
                                            }`}
                                        style={activeCategory === category.id ? { borderBottomColor: '#7bae37', color: '#7bae37' } : {}}
                                    >
                                        <span className="mr-2">{category.icon}</span>
                                        {category.name}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Menu Items - Responsive Grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {menuItems[activeCategory].map((item) => (
                                <div key={item.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-all">
                                    <div className="p-4">
                                        <div className="flex justify-between items-start">
                                            <div className="flex-1 min-w-0">
                                                <h3 className="font-bold text-gray-800 break-words">{item.name}</h3>
                                                <p className="text-sm text-gray-600 mt-1 break-words">{item.description}</p>

                                                {item.allergens && (
                                                    <p className="text-xs text-gray-500 mt-1 flex items-start flex-wrap">
                                                        <AlertCircle size={12} className="mr-1 mt-0.5 flex-shrink-0" />
                                                        <span className="break-words">Allergens: {item.allergens}</span>
                                                    </p>
                                                )}

                                                <div className="mt-2">
                                                    <FoodIndicator isVeg={item.isVeg} isSpicy={item.isSpicy} />
                                                </div>
                                            </div>

                                            <div className="text-right ml-2 flex-shrink-0">
                                                <span className="font-bold text-lg" style={{ color: '#7bae37' }}>€{item.price.toFixed(2)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Second Section - Lunch Combinations */}
                {activeSection === 'lunch-combos' && (
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between text-white px-4 py-3 rounded-t shadow gap-2" style={{ backgroundColor: '#7bae37' }}>
                            <div className="flex items-center">
                                <UtensilsCrossed className="mr-2" size={18} />
                                <h3 className="text-sm font-semibold">Lunch Combinations</h3>
                            </div>
                            <p className="opacity-90 text-sm">Weekdays 12:00 PM - 2:00 PM</p>
                        </div>
                        <div className="bg-white px-4 py-3 rounded-b shadow mb-6">
                            <p className="text-gray-700 text-sm">
                                Our lunch combinations offer a complete meal with rice, lentils, and your choice of curry — perfect for a satisfying midday meal!
                            </p>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {lunchCombos.map((combo) => (
                                <ComboItem key={combo.id} combo={combo} />
                            ))}
                        </div>
                    </div>
                )}

                {/* Third Section - Daily Specials */}
                {activeSection === 'daily-menu' && (
                    <div>
                        <div className="flex flex-col sm:flex-row sm:items-center text-white px-4 py-3 rounded shadow gap-2 mb-4" style={{ backgroundColor: '#7bae37' }}>
                            <div className="flex items-center">
                                <Calendar className="mr-2" size={18} />
                                <h3 className="text-sm font-semibold">Daily Specials</h3>
                            </div>
                            <p className="opacity-90 text-sm sm:ml-auto">Salad and Papad are complementary</p>
                        </div>

                        {/* Daily Menu Grid - Mobile Responsive */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
                            {dailyMenu.map((day, idx) => (
                                <DailyMenuCard key={idx} day={day.day} items={day.items} />
                            ))}
                        </div>
                        <p className="text-sm text-gray-500 mt-4 text-center">
                            Note: Daily specials are only available on their respective days
                        </p>
                    </div>
                )}

                {activeSection === 'menu-photo' && (
                    <div>
                        <div className="flex items-center text-white px-4 py-3 rounded shadow mb-4" style={{ backgroundColor: '#7bae37' }}>
                            <FileImage className="mr-2" size={18} />
                            <h3 className="text-sm font-semibold">Full Menu</h3>
                            <p className="opacity-90 text-sm ml-auto truncate hidden sm:block">View our complete menu</p>
                        </div>

                        <div className="flex justify-center px-4">
                            <div className="bg-white p-4 rounded-lg shadow-md w-full max-w-3xl">
                                <div className="aspect-[1/1.414] relative w-full"> {/* A4 aspect ratio */}
                                    {/* Replace with actual menu image path */}
                                    <img
                                        src="/menu-full.jpg"
                                        alt="Our Complete Menu"
                                        className="object-contain w-full h-full border border-gray-200"
                                    />
                                    {/* <div className="absolute bottom-4 right-4 bg-amber-500 text-white px-3 py-1 rounded-full text-sm shadow-md">
                                        A4 Size
                                    </div> */}
                                </div>
                                <div className="mt-4 text-center">
                                    <a href="/menu-full.jpg" download className="inline-flex items-center px-4 py-2 text-white rounded-md transition-colors" style={{ backgroundColor: '#7bae37' }}>
                                        <FileImage size={16} className="mr-2" />
                                        Download Menu PDF
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default Menu;